<template>
  <el-select ref="role" v-model="selected" v-on:keyup.native.enter="enter" v-loading="loading" clearable
    placeholder="Selecione  uma opção" @change="update()">
    <el-option v-for="row of tableData" :key="row.id" :label="row.name" :value="row.id"></el-option>
  </el-select>
</template> 
<script>
import { i18n } from "@/plugin/i18n";
import { RoleService } from "@/services/role/role.services";

export default {
  name: "RoleList",
  props: {
    current: String,
  },
  watch: {
    current() {
      const vm = this;
      if (vm.$props.current) {
        vm.selected = vm.$props.current;
      }
    },
  },
  data() {
    return {
      tableData: [],
      selected: "",
      loading: false,
    };
  },
  mounted() {
    const vm = this;
    vm.fetch();
  },
  methods: {
    update() {
      const vm = this;
      const roleData = vm.tableData.find(x => x.id === vm.selected);
      vm.$emit("input", vm.selected);
      vm.$emit("selected", vm.selected, roleData.name);
    },
    fetch() {
      const vm = this;
      vm.loading = true;
      RoleService.list()
        .then((response) => {
          vm.tableData = response.records;
        })
        .catch((error) => {
          this.$message({ type: "error", message: error });
        }).finally(() => vm.loading = false)
    }
  },
  mounted() {
    const vm = this;
    vm.fetch();
  },
};
</script>
<style scoped>
.el-page-header__left {
  display: flex !important;
}

form {
  margin-top: 20px;
}

@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}
</style>
